import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureStandingOrder(): boolean {
  return useFeatureEnabled('STANDING_ORDER');
}
